// extracted by mini-css-extract-plugin
module.exports =  {"separator":"separator-uSn0j"};